<div class="page">
  <app-page-header itemName="{{ role.name }}" page-title="roles.detail.pageTitle"></app-page-header>
  <div class="page-content">
    <mat-card class="custom-card">
      <mat-card-title>{{ 'roles.detail.editTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.editTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="detailCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <app-creator-updator-box [data]="role"></app-creator-updator-box>
          <div class="form-wrapper mt-3">
            <form [formGroup]="form" (ngSubmit)="onFormSubmit(model)">
              <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
              <mat-spinner-button role="submit" [options]="formBtnOptions" class="btn-elevate">
              </mat-spinner-button>
            </form>
          </div> <!-- /.form-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <mat-card *ngIf="role && loggedUser && loggedUserPermissions.includes('canDeleteRoles')" class="custom-card mt-4">
      <mat-card-title>{{ 'roles.detail.deleteTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.deleteTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="deleteCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <p>{{ 'common.words.deleteTabWarning' | translate }}</p>
          <mat-spinner-button (btnClick)="onDelete()" [options]="deleteBtnOptions"> </mat-spinner-button>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

  </div> <!-- /.page-content -->
</div> <!-- /.page -->